<div class="card purchase-history">
	<div class="header-row">
		<div>
			<strong>Purchase History</strong>
			<!-- <div class="subtext">Summary of purchasing activity by period</div> -->
		</div>
	</div>

	<div class="grid">
		<div class="col-12 xl:col-4">
			<div class="stat-card accent-blue">
				<div class="accent-bar"></div>
				<div class="period">This Month</div>
				<div *ngIf="!loadingThisMonth" class="value">$ {{ formatNumberWithNotation(thisMonthStats.totalCost) }}</div>
				<i *ngIf="loadingThisMonth" class="pi pi-spin pi-spinner loading-spinner"></i>
				<div class="meta">Total Cost</div>
				<div class="mini-grid" *ngIf="!loadingThisMonth">
					<div>
						<div class="mini-label">GRNs</div>
						<div class="mini-value">{{ formatNumberWithNotation(thisMonthStats.grnCount) }}</div>
					</div>
					<div>
						<div class="mini-label">Items</div>
						<div class="mini-value">{{ formatNumberWithNotation(thisMonthStats.itemCount) }}</div>
					</div>
					<div>
						<div class="mini-label">Units</div>
						<div class="mini-value">{{ formatNumberWithNotation(thisMonthStats.unitCount) }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 xl:col-4">
			<div class="stat-card accent-amber">
				<div class="accent-bar"></div>
				<div class="period">Last Month</div>
				<div *ngIf="!loadingLastMonth" class="value">$ {{ formatNumberWithNotation(lstMonthStats.totalCost) }}</div>
				<i *ngIf="loadingLastMonth" class="pi pi-spin pi-spinner loading-spinner"></i>
				<div class="meta">Total Cost</div>
				<div class="mini-grid" *ngIf="!loadingLastMonth">
					<div>
						<div class="mini-label">GRNs</div>
						<div class="mini-value">{{ formatNumberWithNotation(lstMonthStats.grnCount) }}</div>
					</div>
					<div>
						<div class="mini-label">Items</div>
						<div class="mini-value">{{ formatNumberWithNotation(lstMonthStats.itemCount) }}</div>
					</div>
					<div>
						<div class="mini-label">Units</div>
						<div class="mini-value">{{ formatNumberWithNotation(lstMonthStats.unitCount,1) }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 xl:col-4">
			<div class="stat-card accent-green">
				<div class="accent-bar"></div>
				<div class="period">Last 6 Months</div>
				<div *ngIf="!loadingLast6Months" class="value">$ {{ formatNumberWithNotation(last6MonthsStats.totalCost) }}</div>
				<i *ngIf="loadingLast6Months" class="pi pi-spin pi-spinner loading-spinner"></i>
				<div class="meta">Total Cost</div>
				<div class="mini-grid" *ngIf="!loadingLast6Months">
					<div>
						<div class="mini-label">GRNs</div>
						<div class="mini-value">{{ formatNumberWithNotation(last6MonthsStats.grnCount) }}</div>
					</div>
					<div>
						<div class="mini-label">Items</div>
						<div class="mini-value">{{ formatNumberWithNotation(last6MonthsStats.itemCount,1) }}</div>
					</div>
					<div>
						<div class="mini-label">Units</div>
						<div class="mini-value">{{ formatNumberWithNotation(last6MonthsStats.unitCount,0) }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
